import { fisherSciQaRegions, tfGatewayFromFS } from './constants'

export function formatUpperCaseToCapitalize (str) {
  let i
  const frags = str.toLowerCase().split('_')
  for (i = 0; i < frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1)
  }
  return frags.join(' ')
}

export function kebabToCamel (obj) {
  const newObj = {}
  for (const key in obj) {
    /* lint ignore */
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const camelKey = key.replace(/-([a-z])/g, function (g) {
        return g[1].toUpperCase()
      })
      newObj[camelKey] = obj[key]
    }
  }
  return newObj
}

export function debounce (fn, wait) {
  let timer
  return function (...args) {
    if (timer) {
      clearTimeout(timer) // clear any pre-existing timer
    }
    const context = this // get the current context
    timer = setTimeout(() => {
      fn.apply(context, args) // call the function if time expires
    }, wait)
  }
}
export const envTypes = {
  qa4: 'qa4',
  qa1: 'qa1',
  qa: 'qa',
  prod: 'prod',
  dev: 'dev',
  test: 'test'
}

export const domains = {
  thermofisher: {
    [envTypes.qa4]: 'https://www.qa4.thermofisher.com/',
    [envTypes.qa]: 'https://www.qa.thermofisher.com/',
    [envTypes.qa1]: 'https://www.qa.thermofisher.com/',
    [envTypes.prod]: 'https://www.thermofisher.com/'
  },
  fishersci: {
    [envTypes.qa1]: 'https://qa1.fishersci.com/',
    [envTypes.qa]: 'https://qa3.fishersci.com/',
    [envTypes.prod]: 'https://www.fishersci.com/'
  },

  ampliseq: {
    [envTypes.qa]: 'https://test.ampliseq.com/',
    [envTypes.prod]: 'https://www.ampliseq.com/',
    [envTypes.dev]: 'https://dev.ampliseq.com/'
  }
}
export const getChatDomain = function () {
  const hostname = window.location.hostname.toLocaleLowerCase()
  const availableHostnames = Object.keys(domains).join('|')

  const pattern = new RegExp(
    `(www)?((\\w*).)?(${availableHostnames}).((\\w{2}.\\w{2})|(\\w{2,3}))`,
    'gm'
  )
  const match = pattern.exec(hostname)

  // TODO Fix later, for timebeing ampliseq prod url without www
  if (match && match.length === 8 && match[4] === 'ampliseq' && !match[3]) {
    match[3] = ''
  }

  if (match && match.length === 8) {
    const envType =
      !!match[3] && match[3].startsWith(envTypes.qa4)
        ? envTypes.qa4
        : match[3].startsWith(envTypes.dev)
          ? envTypes.dev
          : match[3].startsWith(envTypes.qa1)
            ? envTypes.qa1
            : match[3].startsWith(envTypes.qa) || match[3].startsWith(envTypes.test)
              ? envTypes.qa
              : envTypes.prod
    let domain = match[4]
    // Exception for fishersci qa - ie and uk region
    if (domain === 'fishersci') {
      const region = match[5]
      // For QA1 envType and region ie/uk, return fishersci QA domain
      if (envType === envTypes.qa1 && fisherSciQaRegions.includes(region)) {
        return domains[domain]?.[envTypes.qa] ?? null
      }
      // For QA1 or PROD envType and region sg/my, switch to thermofisher
      if ((envType === envTypes.qa1 || envType === envTypes.prod) && tfGatewayFromFS.includes(region)) {
        domain = 'thermofisher'
        return domains[domain]?.[envType] ?? null
      }
    }
    return domains[domain]?.[envType] ?? null
  }
  return null
}
